// extracted by mini-css-extract-plugin
export default {"cls1":"common-cls1__c9d4253b809673351720","cls2":"common-cls2__fb06164750e0d871d075 common-cls1__c9d4253b809673351720"};